import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { useTranslation } from "../../../lib/hooks/useTranslation.js";
import { debug } from "../../../log.js";
import { useIsUIVisible } from "../../VideoContextProvider/context/state/isUIVisible.js";
import { useIsAdPlaying } from "../../VideoContextProvider/context/state/isAdPlaying.js";
import { useIsReady } from "../../VideoContextProvider/context/state/isReady.js";
import { Backdrop } from "./Backdrop/index.js";
import { Volume } from "./Volume/index.js";
import { PlayPauseButton } from "./PlayPauseButton/index.js";
import { FullScreenButton } from "./FullScreenButton/index.js";
import { SubtitlesButton } from "./SubtitlesButton/index.js";
import { PipButton } from "./PipButton/index.js";
import { LiveLabel } from "./LiveLabel/index.js";
import { useIsVideoBuffering } from "../../VideoContextProvider/context/state/isBuffering.js";
const debugRack = debug.extend("rack");
function Rack({
  showPipButton = false,
  adBlock = false,
  onPipRequest,
  onFullScreenRequest
}) {
  const { t } = useTranslation();
  const isUIVisible = useIsUIVisible();
  const isAdPlaying = useIsAdPlaying();
  const isReady = useIsReady();
  const isBuffering = useIsVideoBuffering();
  debugRack("### DEBUG OMEGA NPM: STEP 2 - Rack received onPipRequest:", !!onPipRequest);
  const AdPlaying = /* @__PURE__ */jsx("span", { className: "omega_adPlaying", children: t("Ad Playing") });
  let PlayButtonOrAdMsg = null;
  let PlayButtonMobileOrNothing = null;
  if (isAdPlaying) {
    PlayButtonOrAdMsg = AdPlaying;
  } else if (!isBuffering) {
    PlayButtonOrAdMsg = /* @__PURE__ */jsx(PlayPauseButton, {});
    PlayButtonMobileOrNothing = /* @__PURE__ */jsx(PlayPauseButton, { mobile: true });
  }
  if (!isReady) {
    return null;
  }
  return /* @__PURE__ */jsxs(Fragment, { children: [
    isAdPlaying && adBlock && /* @__PURE__ */jsx("div", { className: "adBlockSlate", children: /* @__PURE__ */jsx("p", { className: "text", children: "Commercial Break" }) }),
    /* @__PURE__ */jsx(Backdrop, {}),
    /* @__PURE__ */jsx(
      "div",
      {
        className: classNames("omega_center", "omega_playPauseMobileContainer", {
          omega_uiVisible: isUIVisible
        }),
        children: PlayButtonMobileOrNothing
      }
    ),
    /* @__PURE__ */jsxs(
      "div",
      {
        className: classNames("omega_controlRack", {
          omega_uiVisible: isUIVisible
        }),
        children: [
        /* @__PURE__ */jsxs("div", { className: classNames("omega_sections", "omega_left"), children: [
          /* @__PURE__ */jsx(Volume, { isAdPlaying, adBlock }),
          /* @__PURE__ */jsx(LiveLabel, {})]
        }),
        /* @__PURE__ */jsx("div", { className: classNames("omega_sections", "omega_center"), children: PlayButtonOrAdMsg }),
        /* @__PURE__ */jsxs("div", { className: classNames("omega_sections", "omega_right"), children: [
          /* @__PURE__ */jsx(SubtitlesButton, {}),
          showPipButton && /* @__PURE__ */jsx(PipButton, { onPipRequest }),
          /* @__PURE__ */jsx(FullScreenButton, { onFullScreenRequest })]
        })]

      }
    )]
  });
}
export {
  Rack,
  Rack as default };
//# sourceMappingURL=dist/components/VideoContainer/VideoControlRack/Rack.js.map